__turbopack_context__.v({
  "cycleButton": "cycle-toggle-module__ooFnJG__cycleButton",
  "cycleButtonDefault": "cycle-toggle-module__ooFnJG__cycleButtonDefault",
  "cycleButtonSidebar": "cycle-toggle-module__ooFnJG__cycleButtonSidebar",
  "icon": "cycle-toggle-module__ooFnJG__icon",
  "iconActive": "cycle-toggle-module__ooFnJG__iconActive",
  "iconInactive": "cycle-toggle-module__ooFnJG__iconInactive",
  "iconWrapper": "cycle-toggle-module__ooFnJG__iconWrapper",
  "srOnly": "cycle-toggle-module__ooFnJG__srOnly",
});
